export enum ExecutionType {
  WEB = 'WEB'
}
